
/*
 * -- External Imports --
 */
import { useEffect } from "react";
import { createSearchParams, useLocation, useNavigate, useParams } from "react-router-dom";

/*
 * -- Internal Imports --
 */
import { SpeciesTypes } from "../../constants/species/Species";


/*
 * -- Constants --
 */
const ErrorPageRoute = "/error";

/*
 * -- Hooks --
 */
export const useValidateSpeciesRoute = () => {
    const { species: speciesName } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!speciesName) return;

        const speciesList = SpeciesTypes.toArray();

        if (!speciesList.includes(speciesName ?? "")) {
            const formattedSpecies = speciesList.find(x => x.replace(/-/g, '').toLowerCase() == speciesName?.toLowerCase())

            if (!formattedSpecies) {
                navigate({
                    pathname: ErrorPageRoute,
                    search: `?${createSearchParams({ "error": "" })}`
                }, {
                    replace: true
                });
            }
            else {
                navigate({
                    ...location,
                    pathname: location.pathname.replace(`/${speciesName}`, `/${formattedSpecies}`)
                }, {
                    replace: true
                });
            }
        }
        
    }, [speciesName]);
}